/**
 * Ancho flexible de un filtro del toolbar, para que todos entren en una fila en `lg`.
 * @param {number} [grow] Factor de crecimiento.
 * @param {number} [basis] Ancho base en píxeles.
 * @returns {Object} `sx` del campo.
 */
export const getFilterFieldSx = (grow = 1, basis = 130) => ({
  flex: `${grow} 1 ${basis}px`,
  minWidth: 0,
  mt: 0,
});
